/**
 * Noop fetch implementation for server-side usage
 * Prevents from making actual HTTP requests during SSR
 */
export const noopFetch: typeof fetch = async (
  _input: URL | RequestInfo,
  _init?: RequestInit,
): Promise<Response> => {
  return {
    ok: true,
    status: 200,
    statusText: 'OK',
    headers: new Headers(),
    redirected: false,
    type: 'default' as ResponseType,
    url: '',
    clone: () => {
      throw new Error('Not Implemented')
    },
    body: null,
    bodyUsed: false,
    bytes: async (): Promise<Uint8Array> => {
      throw new Error('Not Implemented')
    },
    async arrayBuffer(): Promise<ArrayBuffer> {
      throw new Error('Not Implemented')
    },
    async blob(): Promise<Blob> {
      throw new Error('Not Implemented')
    },
    async formData(): Promise<FormData> {
      throw new Error('Not Implemented')
    },
    async json() {
      return {}
    },
    async text(): Promise<string> {
      return ''
    },
  } as Response
}
